window.angular.module('MyHippoProducer.Components').directive('emptyResults', function () {
    return {
        restrict: 'E',
        scope: {
        },
        templateUrl: 'components/empty-results/empty-results.html',
    };
});
